

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { PolicyHullExtensionContextStore, ACTIONS } from '../../../context/PolicyHullExtensionContext';
import { useLocation, useParams } from 'react-router-dom';
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel';
var classNames = require('classnames')

export const NumberOfDronesPopover = (props) => {
  const location = useLocation()
  
  return (
      <SkyInformationPopover eventId={'number-of-drones'}>        
            <div className="text-small"> {props.disabled ? 'This field cannot be changed during an active policy, for more information contact us.' : 'This is the number of drones in your fleet that you or your company will operate during the policy period, including those your rent/lease/borrow.'}</div>
        </SkyInformationPopover>
  );
}